"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchAvailableNotificationPreferences = exports.useAvailableNotificationPreferences = exports.AVAILABLE_NOTIFICATION_PREFERENCES_KEY = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const frontend_infra_reactquery_1 = require("@forto-dev/frontend-infra-reactquery");
const frontend_infra_snack_1 = require("@forto-dev/frontend-infra-snack");
const ui_platform_http_1 = require("@forto-dev/ui-platform-http");
const translations_1 = require("../../../features/NotificationsSettings/types/translations");
const ConfigContext_1 = require("../../../lib/ConfigContext");
exports.AVAILABLE_NOTIFICATION_PREFERENCES_KEY = 'availableNotificationPreferences';
const useAvailableNotificationPreferences = () => {
    const snackService = (0, frontend_infra_snack_1.useSnackService)();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const fetchAvailableNotificationPreferences = (0, exports.useFetchAvailableNotificationPreferences)();
    return (0, frontend_infra_reactquery_1.useQuery)({
        queryKey: [exports.AVAILABLE_NOTIFICATION_PREFERENCES_KEY],
        queryFn: async () => {
            try {
                return await fetchAvailableNotificationPreferences();
            }
            catch (e) {
                snackService.showError(translate(translations_1.preferenceErrorTranslations.loadError));
                return Promise.reject(e);
            }
        },
    });
};
exports.useAvailableNotificationPreferences = useAvailableNotificationPreferences;
const useFetchAvailableNotificationPreferences = () => {
    const { state: { token }, } = (0, frontend_infra_auth_1.useAuth)();
    const config = (0, ConfigContext_1.useConfigContext)();
    return async () => {
        const url = `${config.NOTIFICATION_CENTER_ENDPOINT}/user-notification-preferences/available`;
        const response = await ui_platform_http_1.HttpBaseApi.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    };
};
exports.useFetchAvailableNotificationPreferences = useFetchAvailableNotificationPreferences;
//# sourceMappingURL=getAvailableNotificationPreferences.js.map